"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _dateFormatting = _interopRequireDefault(require("@insided/shared/utils/dateFormatting"));

var _classnames = _interopRequireDefault(require("classnames"));

var ArticleEditListItem = function ArticleEditListItem(_ref) {
  var editedAt = _ref.editedAt,
      editedBy = _ref.editedBy,
      isLatest = _ref.isLatest,
      isSelected = _ref.isSelected,
      _onClick = _ref.onClick,
      key = _ref.key;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('article-versions__edit', isSelected && 'selected'),
    onClick: function onClick() {
      return _onClick(editedAt);
    },
    key: key
  }, (0, _preact.h)("div", {
    className: "article-versions__edit-header"
  }, (0, _preact.h)("div", {
    className: "article-versions__edit-date"
  }, (0, _dateFormatting.default)(editedAt)), isLatest && (0, _preact.h)("div", {
    className: "article-versions__edit-latest"
  }, "Current Version")), (0, _preact.h)("div", {
    className: "article-versions__edit-editor"
  }, editedBy));
};

var _default = ArticleEditListItem;
exports.default = _default;